import { createPubSub } from './pubsub';
import { JournalEvent, JournalLogEventArgs, SubscribeArgs } from './types';

const stubTrue = () => true;

export function createJournal<TEventPayload, TEventCategory>() {
  const pubSub = createPubSub<{ Journal: JournalEvent<TEventPayload, TEventCategory> }>();
  const subscriptions = new Set<{ unsubscribe: () => void }>();

  function createHandler({ filter = stubTrue, handler }: SubscribeArgs<TEventPayload, TEventCategory>) {
    return function handleMessage(event: JournalEvent<TEventPayload, TEventCategory>) {
      if (filter(event)) {
        handler(event);
      }
    };
  }

  function log(message: JournalLogEventArgs<TEventPayload, TEventCategory>) {
    pubSub.publish('Journal', { ...message, timestamp: Date.now() });
  }

  function subscribe({ filter, handler }: SubscribeArgs<TEventPayload, TEventCategory>) {
    const unsubscribe = pubSub.subscribe('Journal', createHandler({ filter, handler }));

    subscriptions.add({ unsubscribe });

    return unsubscribe;
  }

  function unsubscribeAll() {
    subscriptions.forEach(({ unsubscribe }) => unsubscribe());

    subscriptions.clear();
  }

  return {
    log,
    subscribe,
    unsubscribeAll,
  };
}
